<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <h1>{{ $t('passwords.password_reset_title') }}</h1>
                <p class="text-muted">{{ $t('passwords.password_reset_description') }}</p>
                <p class="text-danger" v-if="errorMsg.token">{{ errorMsg.token[0] }}</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input ref="password" type="password" class="form-control"
                                :placeholder=" $t('global.password') "
                                :class="{ 'is-invalid' : errorMsg.password }"
                                v-model="password"/>
                  <div class="invalid-feedback" v-if="errorMsg.password">{{ errorMsg.password[0] }}</div>
                </b-input-group>

                <b-input-group class="mb-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input type="password" class="form-control"
                                :placeholder=" $t('global.password_repeat') "
                                :class="{ 'is-invalid' : errorMsg.password_confirmation }"
                                v-model="password_confirmation"/>
                  <div class="invalid-feedback" v-if="errorMsg.password_confirmation">
                    {{ errorMsg.password_confirmation[0] }}
                  </div>
                </b-input-group>

                <b-button variant="success" block @click="reset()">{{ $t('global.reset') }}</b-button>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Services from '@/services/index';

export default {
  mounted() {
    this.$refs.password.$el.focus();
  },
  data() {
    return {
      password: '',
      password_confirmation: '',
      errorMsg: {}
    };
  },
  computed: {},
  methods: {
    reset() {
      Services.auth.resetPassword({
        ...this.$data,
        token: this.$route.params.token
      }).then(() => {
        this.$router.push({ name: 'Login' });
      }).catch(({ errors, message }) => {
        this.errorMsg = errors;
      });
    }
  }
};

</script>
